export const companyFeatures = [
    {
        id: 1,
        icon: '#icon-linegraph',
        title: 'Exponential Growth',
        text: 'We started out as a small travel agency in 2010. Our company has been growing exponentially ever since'
    },
    {
        id: 2,
        icon: '#icon-telescope',
        title: 'Innovation',
        text: 'We strive to improve and innovate our products to deliver one stop service for your travel needs '
    },
    {
        id: 3,
        icon: '#icon-profile-female',
        title: 'Top Talent',
        text: 'Team consists of trip-planning experts and experienced tour leaders'
    },
    {
        id: 4,
        icon: '#icon-chat',
        title: 'Customer Support',
        text: 'Contact us anytime. We are here for you'
    }
];

export const companyValues = [
    {
        id: 5,
        icon: '#icon-users',
        title: 'Moral',
        text: 'Values are qualities which are worth striving for and which are regarded as virtuous and morally right.'
    },
    {
        id: 6,
        icon: '#icon-megaphone',
        title: 'Transparency',
        text: 'Openess with our team and customers. We raise issues and provide solutions promptly.'
    },
    {
        id: 7,
        icon: '#icon-target-arrow',
        title: 'Commitment',
        text: 'Our word and hard work over everything else. Our customers and vision are our guiding beacons.'
    },
    {
        id: 8,
        icon: '#icon-rocket',
        title: 'Self Improvement',
        text: 'Never stop learning, never stop evolving into who we want to be and where we want to be.'
    }
];